import { appApi, createJsonAccessToken } from './apiInstance';
import { appConfig } from '../config/runtimeConfig';

const apiUrl = appConfig.gatewayUrl;

const mainContext = 'talent';
const module = 'course';

export const newCourse = (talentId, workExperience, userId, accessToken) => appApi(apiUrl, createJsonAccessToken(accessToken)).post(`${mainContext}/${talentId}/${module}/new?userId=${userId}`, { ...workExperience, description: 'No se proporciono descripción' });

export const editCourse = (talentId, workExperience, userId, accessToken) => appApi(apiUrl, createJsonAccessToken(accessToken)).put(`${mainContext}/${talentId}/${module}/edit?userId=${userId}`, workExperience);

export const getCourses = (talentId, accessToken) => appApi(apiUrl, createJsonAccessToken(accessToken)).get(`${mainContext}/${talentId}/${module}`);

export const deleteCourse = (talentId, id, userId, accessToken) => appApi(apiUrl, createJsonAccessToken(accessToken)).delete(`${mainContext}/${talentId}/${module}/${id}/delete?userId=${userId}`);
